export default class ChronoFaq {
    constructor() {
      console.log("ChronoContact :: init");
    
      addListeners();
  
      function addListeners() {
        let iframeSpan = document.querySelector("main .iframe");
  
        if (iframeSpan) {
            const iframe = document.createElement('iframe');
            iframe.src = iframeSpan.getAttribute('data-src');
            iframeSpan.remove();
            document.querySelector("#maincontent").appendChild(iframe);

            
        }
      }
    }
  }
  